import gql from 'graphql-tag'

export default gql`
  fragment FieldNoteData on FieldNoteNode {
      note
  }
`